export const DATETIME_ROUND_TO_START = 'start';
export const DATETIME_ROUND_TO_END = 'end';
export const DATETIME_ROUND_TO = {
	START: DATETIME_ROUND_TO_START,
	END: DATETIME_ROUND_TO_END
};
export const DATETIME_ROUND_TOS = [DATETIME_ROUND_TO_START, DATETIME_ROUND_TO_END];